var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "DailyChallengeBase",
    [
      _vm.xpModalIsVisible
        ? _c("DailyChallengeXPHeader", {
            on: { "dc-xp-modal-dismissed": _vm.dismissXpModal }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "daily-challenges" },
        _vm._l(_vm.dcs, function(dc) {
          return _c(
            "div",
            { key: dc.id },
            [_c("DailyChallengeCard", { attrs: { "daily-challenge": dc } })],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.user.is_authenticated
        ? _c(
            "footer",
            { staticClass: "dp-feed-end" },
            [
              _c("p", { staticClass: "b-title-meta" }, [
                _vm._v(
                  _vm._s(_vm.archivesCount) +
                    " daily challenges in the archives"
                )
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "btn",
                  attrs: { to: { name: "daily_problems_archives" } }
                },
                [_vm._v("Open archives")]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }